import * as React from 'react'
import PropTypes from 'prop-types'

const FlexIcon = ({
  size = 16,
  height = 16,
  width = 40,
  svgRef,
  title,
  style = {},
  ...props
}) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 430.6 250.59"
    height={height || size}
    width={width || size}
    ref={svgRef}
    aria-labelledby={title ? title : undefined}
    style={{ pointerEvents: 'none', ...style }}
    {...props}
  >
    <defs>
      <style>
        {`
          .cls-1 { fill: none; }
          .cls-2 { clip-path: url(#clippath); }
          .cls-3 { fill: #6a3db8; }
          .cls-4, .cls-5 { fill: #0e0622; }
          .cls-5 { fill-rule: evenodd; }
        `}
      </style>
      <clipPath id="clippath">
        <rect className="cls-1" x="65.3" y="65.3" width="300" height="119.98" />
      </clipPath>
    </defs>
    <g className="cls-2">
      <g>
        <path
          className="cls-3"
          d="M339.93,179.67c-2.87-2.79-4.43-6.63-4.39-10.64-.08-3.97,1.52-7.77,4.39-10.47,2.7-2.87,6.46-4.43,10.43-4.43,3.97-.04,7.81,1.56,10.55,4.43,2.87,2.7,4.48,6.5,4.39,10.47-.04,8.23-6.75,14.9-14.99,14.86-3.88,0-7.6-1.52-10.39-4.22h0Z"
        />
        <path
          className="cls-4"
          d="M247.89,182.63l28.16-39.73-28.16-39.43h25.42c.97,1.39,3.59,5.32,7.89,11.74,4.39,6.33,7.01,10.26,7.89,11.74l15.62-23.47h24.28l-27.69,38.76,28.62,40.36h-25.12l-16.55-24.28c-.55,.84-2.07,3.17-4.64,6.92-2.49,3.76-4.86,7.3-7.09,10.6l-4.52,6.75-24.11,.04Z"
        />
        <path
          className="cls-5"
          d="M226.87,154.89l17.86,5.32c-2.15,7.3-6.37,13.3-12.71,18.03-6.21,4.73-13.97,7.09-23.3,7.09-11.36,0-21.02-3.8-28.96-11.44-7.94-7.73-11.91-18.03-11.91-30.9,0-12.2,3.84-22.21,11.57-29.93,7.73-7.81,16.84-11.74,27.36-11.74,12.24,0,21.78,3.63,28.62,10.93,6.97,7.26,10.47,17.31,10.47,30.06,0,3.5,0,3.38-.34,6.59h-56.61c.13,4.98,2.36,9.63,6.12,12.88,3.84,3.42,8.49,5.15,13.85,5.15,9.12,.04,15.11-3.97,17.98-12.03Zm-6.92-31.71c3,2.96,4.73,6.92,4.81,11.1h-35.38c.21-3.97,1.94-7.56,5.15-10.77s7.39-4.81,12.54-4.81c5.7,0,10.01,1.48,12.88,4.48Z"
        />
        <path
          className="cls-4"
          d="M154.26,182.88h-21.4V66.4h21.4v116.48Z"
        />
        <path
          className="cls-4"
          d="M111.15,84.13c-2.83-.04-5.61,.84-7.89,2.58-2.15,1.6-3.21,4.39-3.21,8.36v8.7h17.86v18.32h-17.86v60.79h-21.57v-60.79h-13.17v-18.32h13.17v-8.99c0-8.91,2.58-16.04,7.73-21.4,5.24-5.36,12.29-8.06,21.07-8.06,4.73,0,8.27,.55,10.6,1.6v18.03c-2.15-.59-4.43-.89-6.71-.8Z"
        />
      </g>
    </g>
  </svg>
)

FlexIcon.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export { FlexIcon }